<template>
    <div class="dynamic-bg-box">
        <!-- <div class="shape-box">
            <div
                v-for="(shapeItem, indexItem) in shapes"
                :key="'shape_' + indexItem"
                :class="'shape ' + shapeItem.shape"
                :style="style_shape(shapeItem, indexItem)"></div>
        </div>
        <div class="blur-box"></div>
        <div class="star-box">
            <div class="star" v-for="(starItem, starIndex) in stars" :key="'star_' + starIndex" :style="style_star(starItem)"></div>
        </div> -->
        <!-- 插槽的位置 -->
        <div class="slot-box">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';

const shapes = ref([]); // 图形
const stars = ref([]); // 存储星星的数组
const screenWidth = ref(0);
const screenHeight = ref(0);

const polygonClipPaths = computed(() => {
    return shapes.value.map((shape) => {
        return 'polygon(' + shape.points.map((point) => `${point.x}% ${point.y}%`).join(', ') + ')';
    });
});

const style_shape = computed(() => {
    return function (shape, index) {
        return {
            backgroundColor: shape.color,
            width: shape.size + 'px',
            height: shape.size + 'px',
            top: shape.y + 'px',
            left: shape.x + 'px',
            animationDuration: shape.animationDuration + 's',
            filter: 'blur(' + shape.blur + 'px)',
            clipPath: polygonClipPaths[index],
            position: 'absolute',
            '--animationDistanceX': shape.animationDistanceX,
            '--animationDistanceY': shape.animationDistanceY,
        };
    };
});

const style_star = computed(() => {
    return function (star) {
        return {
            width: `${star.size}px`, // 设置宽度
            height: `${star.size}px`, // 设置高度
            backgroundColor: 'white', // 设置背景颜色为白色
            borderRadius: '50%', // 设置圆角，让星星变成圆形
            position: 'absolute', // 设置绝对定位
            top: `${star.y}%`, // 设置 y 坐标
            left: `${star.x}%`, // 设置 x 坐标
            opacity: star.opacity, // 设置透明度
            filter: 'blur(' + star.blur + 'px)',
        };
    };
});

onMounted(() => {
    screenWidth.value = window.innerWidth;
    screenHeight.value = window.innerHeight;
    generateShapes(); // 生成多边形
    generateStars(); // 生成星星
});

const generateShapes = () => {
    // 生成随机形状、颜色、大小、位置、动画时长和模糊程度的形状
    for (let i = 0; i < 20; i++) {
        const randomDirection = Math.random() < 0.5 ? 1 : -1; // 随机选择正向或负向运动
        const randomDistanceX = `${randomDirection * (Math.random() * 800 - 200)}px`; // 在-200到200之间生成随机距离
        const randomDistanceY = `${randomDirection * (Math.random() * 800 - 150)}px`; // 在-150到150之间生成随机距离

        shapes.value.push({
            shape: 'polygon',
            color: getRandomColor(),
            size: Math.random() * 100 + 100,
            x: Math.random() * screenWidth.value,
            y: Math.random() * screenHeight.value,
            animationDuration: Math.random() * 5 + 5,
            blur: Math.random() * 50,
            points: getRandomPolygonPoints(),
            animationDistanceX: randomDistanceX,
            animationDistanceY: randomDistanceY,
        });
    }
};

const getRandomColor = () => {
    // 偏暗颜色的范围控制在 0 到 150 之间 （偏暗一点【0-255】）
    const getRandomChannelValue = () => Math.floor(Math.random() * 128);
    
    const red = getRandomChannelValue();
    const green = getRandomChannelValue();
    const blue = getRandomChannelValue();
    
    const toHex = (value) => {
        const hex = value.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };
    return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
};
const getRandomPolygonPoints = () => {
    // 生成随机多边形的顶点
    const points = [];
    const numPoints = Math.floor(Math.random() * 5) + 3; // 随机3到7个顶点
    for (let i = 0; i < numPoints; i++) {
        points.push({
            x: Math.random() * 100,
            y: Math.random() * 100,
        });
    }
    return points;
};
const generateStars = () => {
    // 生成随机数量的星星
    const numStars = Math.floor(Math.random() * 50) + 50; // 随机数量在 50 到 100 之间
    for (let i = 0; i < numStars; i++) {
        stars.value.push({
            x: Math.random() * 100, // 随机 x 坐标
            y: Math.random() * 100, // 随机 y 坐标
            size: Math.random() * 2 + 1, // 随机大小
            opacity: Math.random(), // 随机透明度
            blur: Math.random() * 5,
        });
    }
};
</script>

<style scoped>
:root {
    --animationDistanceX: -200px;
    --animationDistanceY: 150px;
}

.dynamic-bg-box {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    /* background-color: rgb(19, 19, 38); */
    overflow: hidden;
}

.shape-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.shape {
    position: absolute;
    animation: flow 10s ease-in-out infinite alternate;
}

@keyframes flow {
    from {
        transform: translate(0, 0);
    }

    to {
        transform: translate(var(--animationDistanceX), var(--animationDistanceY));
    }
}

.blur-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(180px);
}

.star-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.star {
    animation: starAnim 15s ease-in-out infinite alternate;
}

@keyframes starAnim {
    0% {
        opacity: 1;
        transform: translate(0, 0);
    }

    50% {
        opacity: 0;
        transform: translate(-100px, -150px);
    }

    100% {
        opacity: 1;
        transform: translate(200px, 150px);
    }
}

.slot-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
